export enum LlOptionEnum {
  NewExpressions = 0,
  OnlyOneTable = 1,
  //
  // Summary:
  //     See TableColoring Property
  TableColoring = 2,
  //
  // Summary:
  //     TRUE:
  //
  //     All menu options are allowed and even locked objects are not locked. This mode
  //     enables parts which are not accessible to the user to be used without much additional
  //     programming.
  //
  //     FALSE:
  //
  //     Limitations are valid (Default).
  SuperVisor = 3,
  //
  // Summary:
  //     See Unit Property
  Units = 4,
  //
  // Summary:
  //     LL_TABS_DELETE (0):
  //
  //     List & Label replaces tabs (code 0x09) in a text by spaces (Default).
  //
  //     LL_TABS_EXPAND (1):
  //
  //     Tabs will be expanded by spaces for a column width of 8 characters. This makes
  //     no sense however for proportional fonts.
  TabStops = 5,
  //
  // Summary:
  //     Any combination of the following values is possible as a value:
  //
  //     LL_CB_PAGE (0x40000000)
  //
  //     LL_CB_PROJECT (0x20000000)
  //
  //     LL_CB_OBJECT (0x10000000)
  //
  //     LL_CB_HELP (0x08000000)
  //
  //     LL_CB_TABLELINE (0x04000000)
  //
  //     LL_CB_TABLEFIELD (0x02000000)
  CallbackMask = 6,
  CallbackParameter = 7,
  //
  // Summary:
  //     TRUE:
  //
  //     Show Help buttons (Default).
  //
  //     FALSE:
  //
  //     Hide help buttons.
  HelpAvailable = 8,
  //
  // Summary:
  //     TRUE:
  //
  //     The variables and fields in the selection dialog are sorted alphabetically.
  //
  //     FALSE:
  //
  //     The variables and fields in the selection dialog are not sorted (Default).
  SortVariables = 9,
  //
  // Summary:
  //     TRUE:
  //
  //     The page break checkbox of the text object is displayed and can be checked by
  //     the user (Default).
  //
  //     FALSE:
  //
  //     The page break checkbox is hidden.
  SupportPagebreak = 10,
  //
  // Summary:
  //     TRUE:
  //
  //     The internal variables of List & Label will be listed in the variable selection
  //     dialog of the formula assistant (Default).
  //
  //     FALSE:
  //
  //     They will be suppressed.
  ShowPredefinedVariables = 11,
  //
  // Summary:
  //     TRUE:
  //
  //     List & Label passes all printer device operations to the host application, which
  //     then has more freedom but also more work. See LL_CMND_HOSTPRINTER.
  //
  //     FALSE:
  //
  //     List & Label manages the printer device (Default).
  UseHostprinter = 13,
  ExtendedEvaluation = 14,
  //
  // Summary:
  //     Character code of the character that represents the "tab".
  TabRepresentationCode = 15,
  //
  // Summary:
  //     See Unit Property
  Metric = 18,
  //
  // Summary:
  //     See AddVarsToFields Property
  AddVarsToFields = 19,
  //
  // Summary:
  //     See ConvertCRLF Property
  ConvertCRLF = 21,
  Wizard_FileNew = 22,
  //
  // Summary:
  //     Value of the new character, which represents a return (Default: "¶").
  ReturnRepresentationCode = 23,
  //
  // Summary:
  //     See PreviewZoom Property
  Preview_Zoom_Percent = 25,
  //
  // Summary:
  //     The initial left position of the real data preview window in pixels. Initially
  //     the position of the window it had when last closed is taken.
  Preview_RectLeft = 26,
  //
  // Summary:
  //     The initial top position of the real data preview window in pixels. Initially
  //     the position of the window it had when last closed is taken.
  Preview_RectTop = 27,
  //
  // Summary:
  //     The initial width of the real data preview window in pixels. Initially the width
  //     of the window it had when last closed is taken.
  Preview_RectWidth = 28,
  //
  // Summary:
  //     The initial height of the real data preview window in pixels. Initially the Height
  //     of the window it had when last closed is taken.
  Preview_RectHeight = 29,
  StorageSystem = 30,
  //
  // Summary:
  //     See CompressStorage Property
  CompressStorage = 31,
  //
  // Summary:
  //     TRUE:
  //
  //     List & Label does not check the parameters passed to its DLL functions, which
  //     results in a higher processing speed.
  //
  //     FALSE:
  //
  //     The parameters will be checked (Default).
  NoParameterCheck = 32,
  //
  // Summary:
  //     TRUE:
  //
  //     For a list project, List & Label does not check whether at least one table object
  //     is present.
  //
  //     FALSE:
  //
  //     List & Label does the check and returns LL_ERR_NO_TABLEOBJECT if the project
  //     contains no table. (Default)
  NoNoTableCheck = 33,
  DrawFooterLineOnPrint = 34,
  //
  // Summary:
  //     The initial left position of the real data preview window in percent of the page
  //     size. Initially the position of the window it had when last closed is taken.
  Preview_Zoom_Left = 35,
  //
  // Summary:
  //     The initial top position of the real data preview window in percent of the page
  //     size. Initially the position of the window it had when last closed is taken.
  Preview_Zoom_Top = 36,
  //
  // Summary:
  //     The initial width of the real data preview window in percent of the page size.
  //     Initially the width of the window it had when last closed is taken.
  Preview_Zoom_Width = 37,
  //
  // Summary:
  //     The initial height of the real data preview window in percent of the page size.
  //     Initially the height of the window it had when last closed is taken.
  Preview_Zoom_Height = 38,
  //
  // Summary:
  //     This does not apply to existing objects!
  //
  //     TRUE:
  //
  //     List & Label will default the "Space Optimization" feature for new paragraphs
  //     in text objects and new fields (Default).
  //
  //     FALSE:
  //
  //     The default state will be unchecked.
  SpaceOptimization = 40,
  //
  // Summary:
  //     TRUE:
  //
  //     Time() and Now() will always use the current time.
  //
  //     FALSE:
  //
  //     The time will be fixed once at project load time (Default).
  Realtime = 41,
  AutoMultiPage = 42,
  //
  // Summary:
  //     TRUE:
  //
  //     Some barcodes have size limitations (minimum and/or maximum sizes). If this option
  //     is set to TRUE, the user is allowed to switch on the size limitation feature
  //     so that resizing the barcode object will only allow sizes in the standard size
  //     range.
  //
  //     FALSE:
  //
  //     All sizes can be set (Default).
  UseBarcodeSizes = 43,
  //
  // Summary:
  //     See MaxRTFVersion Property
  MaxRtfVersion = 44,
  //
  // Summary:
  //     See VarsCaseSensitive Property
  VarsCaseSensitive = 46,
  //
  // Summary:
  //     See DelayTableHeader Property
  DelayTableHeader = 47,
  EmfResolution = 49,
  //
  // Summary:
  //     List & Label can store some information about the user (user and computer name,
  //     date and time of creation as well as last modification) into the project file
  //     and the preview file. This can be important in tracing modifications.
  //
  //     TRUE:
  //
  //     Save info (Default).
  //
  //     FALSE:
  //
  //     Suppress saving info.
  SetCreationInfo = 50,
  //
  // Summary:
  //     TRUE:
  //
  //     Special characters in variable and field names will be converted to "_" (Default).
  //
  //
  //     FALSE:
  //
  //     Variable and field names will not be modified. That has a speed advantage depending
  //     on the number of variables and fields.
  XlatVarnames = 51,
  TranslationFlags = 315,
  //
  // Summary:
  //     Character code of the character that represents a "phantom space".
  PhantomspaceRepresentationCode = 54,
  //
  // Summary:
  //     Character code of the character that represents a "line break lock".
  LockNextCharRepresentationCode = 55,
  //
  // Summary:
  //     Character code of the character that is used to divide an expression in multiple
  //     lines in the formula assistant.
  ExpressionSeparatorRepresentationCode = 56,
  //
  // Summary:
  //     Returns if a default printer is present on the system.
  DefaultPrinterInstalled = 57,
  NoFooterPagewrap = 59,
  ImmediateLastpage = 64,
  //
  // Summary:
  //     When you set this option, the default values for locale dependent parameters
  //     are set accordingly (inch/metic unit, decimal point, thousands separator, currency
  //     symbol and fonts (see LL_OPTION_FORCEFONTCHARSET)). It also defines the default
  //     locale for the Loc...$() and Date$() functions.
  //
  //     Default: LOCALE_USER_DEFAULT.
  LCID = 65,
  //
  // Summary:
  //     Character code of the character that embraces texts.
  TextquoteRepresentationCode = 66,
  //
  // Summary:
  //     Default font. The handle needs not be valid after the API call, an own copy of
  //     the font will be used. This font can be set by LL_OPTIONSTR_DEFDEFFONT.
  //
  //     Default: GetStockObject(ANSI_VAR_FONT)
  DefaultDefaultFont = 69,
  Codepage = 70,
  //
  // Summary:
  //     TRUE:
  //
  //     All fonts in the system are being offered in font selection combo boxes (see
  //     also LL_OPTION_SCALABLEFONTSONLY).
  //
  //     FALSE:
  //
  //     Only the fonts are displayed which support the charset of the default LCID (see
  //     LL_OPTION_LCID) (Default).
  ForceFontCharset = 71,
  //
  // Summary:
  //     TRUE:
  //
  //     The text of an RTF control is stored compressed in the project file (Default).
  //
  //
  //     FALSE:
  //
  //     Text is not compressed in project file (for example for debugging).
  CompressRtf = 72,
  AllowLlxExporters = 74,
  Supports_PRNOPSTR_Export = 75,
  DebugFlag = 76,
  //
  // Summary:
  //     RTF texts may contain blank lines at the end.
  //
  //     TRUE:
  //
  //     These are removed (prevents doubled spaces at the end of the RTF).
  //
  //     FALSE:
  //
  //     The blank lines are printed.
  SkipReturnAtEndOfRtf = 77,
  //
  // Summary:
  //     TRUE:
  //
  //     The space between the characters for block justified text will vary.
  //
  //     FALSE:
  //
  //     Only the width of blanks between words will be varied (Default).
  InterCharSpacing = 78,
  //
  // Summary:
  //     See IncludeFontDescent Property
  IncludeFontDescent = 79,
  ResolutioncompatibleTo9x = 80,
  UseChartFields = 81,
  OpenFileDialog_NoPlacesBar = 82,
  //
  // Summary:
  //     This option sets the color depth of the sketch files for the file selection dialogs.
  //     Default is 1, i.e. monochrome, 32 would be True-Color for example.
  SketchColorDepth = 83,
  LLXInterface = 53,
  //
  // Summary:
  //     See DialogMode Property
  UIStyle = 99,
  //
  // Summary:
  //     This option defines the behavior of the designer while opening a project file
  //     from an older version of List & Label.
  //
  //     TRUE:
  //
  //     Conversion takes place without user interaction.
  //
  //     FALSE:
  //
  //     A warning box is displayed to the user, telling that the project file will not
  //     be editable by an older version of List & Label once it has been saved with the
  //     current version (Default).
  NoFileVersionUpgradeWarning = 100,
  //
  // Summary:
  //     Raster fonts have the disadvantage of not being scalable, so the preview can
  //     look unexpectedly.
  //
  //     TRUE:
  //
  //     Only scalable fonts are selectable in the font selection dialogs (TrueType and
  //     Vector fonts (Default).
  //
  //     FALSE:
  //
  //     All fonts are selectable in the font selection dialogs.
  ScalableFontsOnly = 67,
  //
  // Summary:
  //     Here you can choose whether the printing supervision is activated or not. See
  //     also PrintJobInfo Event
  NoPrintJobSupervision = 106,
  //
  // Summary:
  //     Tells List & Label that all MessageBoxes will be automatically answered.
  ProhibitUserInteraction = 109,
  //
  // Summary:
  //     TRUE:
  //
  //     "Escape" key closes the preview window.
  //
  //     FALSE:
  //
  //     "Escape" key does not close the preview window (Default).
  EscClosesPreview = 102,
  //
  // Summary:
  //     See IncrementalPreview Property
  IncrementalPreview = 135,
  NoPrinterPathCheck = 137,
  //
  // Summary:
  //     TRUE:
  //
  //     The sum variables are updated as soon as one data line for the record has been
  //     printed.
  //
  //     FALSE:
  //
  //     The sum variables are updated as soon as all data lines have been completely
  //     printed (Default).
  CalcSumVarsOnPartialLines = 107,
  //
  // Summary:
  //     TRUE:
  //
  //     Interdependent properties can be set independently. This option is sometimes
  //     required when working with the DOM object model to prevent automatic property
  //     switching. If e.g. the font of a paragraph is set to a Chinese font, the property
  //     "Charset" would be automatically switched accordingly. If this is not desired,
  //     use this option to switch the behavior.
  //
  //     FALSE:
  //
  //     Setting interdependent properties mutually influences each other (Default).
  NoAutoPropertyCorrection = 139,
  //
  // Summary:
  //     In order to enable the direct preview within the designer, you have to set LL_OPTION_DESIGNERPREVIEWPARAMETER
  //     for the preview of real data.
  //
  //     See the Programmer's Manual, chapter 'Direct Printing and Export from the Designer'.
  DesignerPreviewParameter = 141,
  //
  // Summary:
  //     In order to enable the direct preview within the designer, you have to set LL_OPTION_DESIGNEREXPORTPARAMETER
  //     for the export from the designer.
  //
  //     See the Programmer's Manual, chapter 'Direct Printing and Export from the Designer'.
  DesignerExportParameter = 143,
  //
  // Summary:
  //     If your data source only allows single threaded access, you must set LL_OPTION_DESIGNERPRINT_SINGLETHREADED
  //     to TRUE. This will be used by List & Label, so that during the preview calculation
  //     no export is possible, and vice versa.
  //
  //     See the Programmer's Manual, chapter 'Direct Printing and Export from the Designer'.
  DesignerPrintSingleThreaded = 144,
  DrillDownParameter = 162,
  //
  // Summary:
  //     With this option the rounding strategy can be set by one of the following values:
  //
  //
  //     LL_ROUNDINGSTRATEGY_BANKERSROUNDING (0)LL_ROUNDINGSTRATEGY_ARITHMETIC_SYMMETRIC
  //     (1) (Default).
  RoundingStrategy = 163,
  CalcSumVarsOnInvisibleLines = 58,
  RibbonDefaultEnabledState = 217,
  AllowCombinedCollectingOfDataForCollectionControls = 222,
  SuppressLoadErrorMessages = 223,
  ReportParameterJobParameter = 234,
  ExpandableRegionsJobParameter = 235,
  InteractiveSortingJobParameter = 237,
  DataproviderThreadedness = 257,
  ScriptingEngineEnabled = 276,
  ScriptingEngineTimeoutMs = 277,
  ScriptingEngineAutoExecute = 278,
  ProjectBackup = 115,
  PrintedRecordsCount = 280,
  AutoRecoverySaveOptions = 287,
  ForceUniqueReportParameterDisplayValues = 292,
  //
  // Summary:
  //     Use flags (0x1: Designer, 0x2: Preview Window) to decide where to match the physical
  //     size on screen. Requires Win 8.1 or newer.
  PreviewScalesRelativeToPhysicalSize = 316,
  //
  // Summary:
  //     Use flags to enable or disable the filter edit control. Default: all enabled.
  //
  //
  //     Flag – Bedeutung
  //     0x1 – Main variable/fields window.
  //     0x2 – variable treeview in fuction wizard.
  TreeviewFilterVisibilityFlags = 318,
  TreeviewFilterMaximumRecursionDepth = 320,
  GetCurrentProjectType = 328,
  ImprovedTableLineAnchoring = 236,
  SaveProjectInUtf8 = 178,
  Printerless = 375,
  //
  // Summary:
  //     This option is important for optimizing text placement in environments without
  //     printer drivers (see Printerless). Too small a magnification can lead to "poor"
  //     placement accuracy of output, a too large one (option value between 72 and 2400)
  //     can result in objects or parts of them not being output. In any case, you should
  //     check the results in the target environment.
  //
  //     The following values can be used:
  //
  //     Value – Meaning
  //     0x00 – The project is rendered 1:1 in the selected size with the screen device
  //     context as reference with the resolution/size of the screen context - can lead
  //     to inaccuracies in the placement of outputs if they are calculated using the
  //     device coordinates (default).
  //     0x01 – The resolution for the output is converted so that it is optimally fitted
  //     to the size of the screen device context.
  //     0x02 – The resolution for the output is converted to fit the size of the screen
  //     device context exactly, provided that the resolution does not have to be reduced
  //     for this purpose.
  //     72-2400 – The resolution for the output in DPI.
  VirtualDeviceScalingOptions = 379,

  //
  // Summary:
  //     TRUE:
  //
  //     The standard simple frame lines for tables and objects such as dotted, dashed,
  //     dashed-dotted, and dashed-dotted-dotted are more effectively output directly
  //     by Windows and the PDF viewer, respectively. May result in higher overall performance
  //     and smaller export files when creating reports.
  //
  //     FALSE:
  //
  //     Uses a custom drawing method (individual objects) to output frame lines. This
  //     can lead to better results when outputting to printers (Default).
  UseSimpleWindowsPenStyleFrameDrawing = 389,

  // (0)=speed, 1=size, 2=security
  TempFileStrategy = 238,

  // default: 100
  RtfShareObjectsThreshold = 383,
}
